import { Breakpoint as VelocityBreakpoint } from '../Breakpoint/Breakpoint';
var MUI_BREAKPOINTS = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
];
var breakpoints = function () { return ({
    values: MUI_BREAKPOINTS.reduce(function (acc, key) {
        var velocityBreakpoint = mapBreakpoint(key);
        if (velocityBreakpoint) {
            acc[key] = velocityBreakpoint;
        }
        return acc;
    }, {}),
}); };
export default breakpoints;
function mapBreakpoint(muiBreakpointName) {
    switch (muiBreakpointName) {
        case 'xs':
            return VelocityBreakpoint.mobile;
        case 'sm':
            return VelocityBreakpoint.mobileLandscape;
        case 'md':
            return VelocityBreakpoint.tablet;
        case 'lg':
            return VelocityBreakpoint.lap;
        case 'xl':
            return VelocityBreakpoint.desktop;
        default:
            return null;
    }
}
//# sourceMappingURL=breakpoints.js.map